import FileUploadIcon from '@resources/icons/FileUploadIcon.svg?react';
import { FileSource, TeiaViewerSourceType, ToolbarItem, TwinSource } from '@stereograph/teiaviewer';
import { usePluginTranslation } from '@translation';
import { ChangeEvent, useRef } from 'react';
import { useImportBcfAnomaly } from '../hooks/useImportBcfAnomaly';
import { useImportCsvAnomaly } from '../hooks/useImportCsvAnomaly';
import { dissociateImportedFile } from '../utils/dissociateImportedFile';
import { ACCEPTED_ANOMALY_FILE_TYPE } from '../widgets/types';

interface AnomalyUploadToolbarItemProps {
  source: TwinSource | FileSource;
}

export const AnomalyUploadToolbarItem = (props: AnomalyUploadToolbarItemProps) => {
  const { source } = props;
  const { t } = usePluginTranslation();
  const fileInputRef = useRef<HTMLInputElement>(null);

  const twinProjectType = source.sourceType === TeiaViewerSourceType.Twin ? source.type : 'Draft';

  const { importBcfAnomaly } = useImportBcfAnomaly(source.projectId);
  const { importCsvAnomaly } = useImportCsvAnomaly(source.projectId);

  const handleFileClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;

    if (!files || files.length === 0) {
      return;
    }

    const { bcfFiles, excelFiles } = dissociateImportedFile(files);

    if (bcfFiles.length > 0) {
      importBcfAnomaly({
        files: bcfFiles,
        twinProjectType,
      });
    }
    if (excelFiles.length > 0) {
      importCsvAnomaly({
        files: excelFiles,
        twinProjectType,
      });
    }
    event.target.value = '';
  };

  return (
    <>
      <ToolbarItem
        hidden={source === null}
        icon={FileUploadIcon}
        label={t('anomaly_plugin.info_widget.upload.tooltip')}
        onClick={handleFileClick}
        data-dd-action-name="tvp.anomaly.upload"
      />
      <input
        className="st-sr-only"
        type="file"
        accept={ACCEPTED_ANOMALY_FILE_TYPE.join(',')}
        id="upload-anomaly"
        hidden
        ref={fileInputRef}
        onChange={handleFileChange}
        multiple
      />
    </>
  );
};
